export default __webpack_public_path__ + "static/media/sidebar.f57df45c.svg";